export const UPDATE_USER_LAT_LONG = 'UPDATE_USER_LAT_LONG'
export const SET_REQUEST_LOCALE = 'SET_REQUEST_LOCALE'

export const ERROR_REPORTED = 'ERROR_REPORTED'

// System actions
export const SET_HEADLESS_MODE = 'SET_HEADLESS_MODE'
export const SET_EXPERIMENT = 'SET_EXPERIMENT'
export const UPDATE_APPLE_PAY_AVAILABLE = 'UPDATE_APPLE_PAY_AVAILABLE'
export const UPDATE_GOOGLE_PAY_AVAILABLE = 'UPDATE_GOOGLE_PAY_AVAILABLE'
export const DECLINE_NEWSLETTER_SUBSCRIPTION = 'DECLINE_NEWSLETTER_SUBSCRIPTION'
export const TOGGLE_SHOW_MARGIN_IN_SPOOF_MODE = 'TOGGLE_SHOW_MARGIN_SPOOF_MODE'
export const TOGGLE_SHOW_SPOOF_LAUNCHPAD = 'TOGGLE_SHOW_SPOOF_LAUNCHPAD'
export const DISMISS_LUX_PLUS_FREE_PREVIEW_BANNER = 'DISMISS_LUX_PLUS_FREE_PREVIEW_BANNER'
export const DISMISS_BETA_TRIP_BANNER = 'DISMISS_BETA_TRIP_BANNER'
export const HOTEL_CANCELLATION_PRICE_CHANGE_MODAL_SEEN = 'HOTEL_CANCELLATION_PRICE_CHANGE_MODAL_SEEN'

// Dev Panel overrides
export const DEV_OVERRIDE_AUTH_ACCOUNT = 'DEV_OVERRIDE_AUTH_ACCOUNT'
export const DEV_OVERRIDE_LOYALTY_STATE = 'DEV_OVERRIDE_LOYALTY_STATE'
export const SET_SEARCH_BURN_ENABLED = 'SET_SEARCH_BURN_ENABLED'
export const CLEAR_SEARCH_BURN_BATCH_CALCULATIONS = 'CLEAR_SEARCH_BURN_BATCH_CALCULATIONS'
export const SET_BUNDLED_BURN_BATCH_RESULT = 'SET_BUNDLED_BURN_BATCH_RESULT'

// Optimizely actions
export const SET_OPTIMIZELY_EXPERIMENTS = 'SET_OPTIMIZELY_EXPERIMENTS'
export const SET_OPTIMIZELY_FEATURE_FLAGS = 'SET_OPTIMIZELY_FEATURE_FLAGS'
export const BEGIN_POST_LOGIN_OPTIMIZELY_SYNC = 'BEGIN_POST_LOGIN_OPTIMIZELY_SYNC'
export const END_POST_LOGIN_OPTIMIZELY_SYNC = 'END_POST_LOGIN_OPTIMIZELY_SYNC'
export const SET_LAB_FEATURE_FLAGS = 'SET_LAB_FEATURE_FLAGS'

// Historical actions
export const ADD_HISTORICAL_ACTION = 'ADD_HISTORICAL_ACTION'
export const CLEAR_HISTORICAL_ACTIONS = 'CLEAR_HISTORICAL_ACTIONS'
export const RESTORE_HISTORICAL_ACTIONS = 'RESTORE_HISTORICAL_ACTIONS'

// Utm actions
export const SET_UTM = 'SET_UTM'

// Auth actions
export const ACCOUNT_INIT_COMPLETE = 'ACCOUNT_INIT_COMPLETE'
export const ACCOUNT_ACCESS_SHOW_LOGIN = 'ACCOUNT_ACCESS_SHOW_LOGIN'
export const ACCOUNT_ACCESS_SHOW_EMAIL_JOIN = 'ACCOUNT_ACCESS_SHOW_EMAIL_JOIN'
export const ACCOUNT_ACCESS_SHOW_FORGOT_PASSWORD = 'ACCOUNT_ACCESS_SHOW_FORGOT_PASSWORD'
export const ACCOUNT_ACCESS_SET_MODE = 'ACCOUNT_ACCESS_SET_MODE'
export const SET_RECENTLY_USED_AIRPORT_CODE = 'SET_RECENTLY_USED_AIRPORT_CODE'
export const SAVE_CUSTOMER_SIGNATURE = 'SAVE_CUSTOMER_SIGNATURE'
export const DELETE_CUSTOMER_SIGNATURE = 'DELETE_CUSTOMER_SIGNATURE'
export const SYNC_USER_DETAILS = 'SYNC_USER_DETAILS'
export const GSI_SCRIPT_LOADED = 'GSI_SCRIPT_LOADED'
export const SET_CUSTOMER_VALUE = 'SET_CUSTOMER_VALUE'
export const CLEAR_AUTH_ERROR = 'CLEAR_AUTH_ERROR'
export const SET_RESOLVED_TRACKING_ID = 'SET_RESOLVED_TRACKING_ID'
// Removed User Cart Actions - all userCart actions are now handled by XState machine

// User notification actions
export const REMOVE_USER_NOTIFICATION = 'REMOVE_USER_NOTIFICATION'
export const VIEW_USER_NOTIFICATIONS = 'VIEW_USER_NOTIFICATIONS'
export const SUBSCRIPTION_USER_NOTIFICATIONS_UPDATE = 'SUBSCRIPTION_USER_NOTIFICATIONS_UPDATE'

// Checkout experience actions
export const CHECKOUT_UPDATE_EXPERIENCE_ITEM = 'CHECKOUT_UPDATE_EXPERIENCE_ITEM'

// Insurance actions
export const RESET_INSURANCE = 'RESET_INSURANCE'
export const INVALIDATE_INSURANCE_QUOTES = 'INVALIDATE_INSURANCE_QUOTES'

// Order actions
export const UPDATE_ORDER = 'UPDATE_ORDER'
export const ADD_ORDERS = 'ADD_ORDERS'
export const REMOVE_ORDER = 'REMOVE_ORDER'
export const ADD_REFUND_REQUEST_TO_ORDER = 'ADD_REFUND_REQUEST_TO_ORDER'
export const CHECKOUT_SET_ORDER_ID = 'CHECKOUT_SET_ORDER_ID'
export const CHECKOUT_SET_PAYMENT_PROGRESS_STEP = 'CHECKOUT_SET_PAYMENT_PROGRESS_STEP'
export const CHECKOUT_SET_PAYMENT_PROGRESS_FAILED = 'CHECKOUT_SET_PAYMENT_PROGRESS_FAILED'
export const PAYMENT_PROGRESS_ORDER_CREATED_STEP = 1
export const PAYMENT_PROGRESS_PAYMENT_STEP = 2
export const PAYMENT_PROGRESS_CUSTOMER_ACTION_STEP = 3
export const PAYMENT_PROGRESS_COMPLETE = 4 // sentinel: when step >= this, all steps are done
export const SET_GUEST_SPECIAL_REQUESTS = 'SET_GUEST_SPECIAL_REQUESTS'
export const UPDATE_FLIGHT_TRAVELLER_DETAILS = 'UPDATE_FLIGHT_TRAVELLER_DETAILS'
export const UPDATE_FLIGHT_RESERVATION_DETAILS = 'UPDATE_FLIGHT_RESERVATION_DETAILS'

// Offer actions
export const OFFERS_CLEAR = 'OFFERS_CLEAR'
export const CLEAR_OFFERS_WITH_DISCOUNT = 'CLEAR_OFFERS_WITH_DISCOUNT'
export const OFFER_SHARE_START = 'OFFER_SHARE_START'
export const OFFER_SHARE_COMPLETE = 'OFFER_SHARE_COMPLETE'
export const OFFER_SET_SEARCH_RESULT_METADATA = 'OFFER_SET_SEARCH_RESULT_METADATA'
export const OFFER_SET_TOUR_SEARCH_RESULT_METADATA = 'OFFER_SET_TOUR_SEARCH_RESULT_METADATA'
export const OFFER_SET_EXPERIENCES_SEARCH_RESULT_METADATA = 'OFFER_SET_EXPERIENCES_SEARCH_RESULT_METADATA'
export const OFFER_VIEWED = 'OFFER_VIEWED'
export const OFFER_UPDATE_PRICING_DATA = 'OFFER_UPDATE_PRICING_DATA'
export const BEDBANK_UPDATE_PRICING_DATA = 'BEDBANK_UPDATE_PRICING_DATA'
export const PROPERTY_UPDATE_PRICING_DATA = 'PROPERTY_UPDATE_PRICING_DATA'
export const OFFER_UPDATE_AVAILABLE_RATES = 'OFFER_UPDATE_AVAILABLE_RATES'
export const OFFER_PUSH_TO_LIST_BOTTOM = 'OFFER_PUSH_TO_LIST_BOTTOM'
export const REMOVE_OFFER = 'REMOVE_OFFER'
export const ADD_OFFER_LIST_EXTRA = 'ADD_OFFER_LIST_EXTRA'
export const END_OFFER_LIST_STREAM = 'END_OFFER_LIST_STREAM'
export const SET_OFFER_LIST_ERROR = 'SET_OFFER_LIST_ERROR'
export const SET_OFFER_LIST_SOCKET_STATUS = 'SET_OFFER_LIST_SOCKET_STATUS'
export const SET_OFFER_LIST_BOUNDS = 'SET_OFFER_LIST_BOUNDS'
export const SET_OFFER_LIST_DESCRIPTION_LOADING = 'SET_OFFER_LIST_DESCRIPTION_LOADING'
export const SET_OFFER_LIST_SELECTED_FILTERS = 'SET_OFFER_LIST_SELECTED_FILTERS'
export const SET_OFFER_LIST_VALID_OFFER = 'SET_OFFER_LIST_VALID_OFFER'
export const UPDATE_OFFER_METADATA_DESCRIPTION = 'UPDATE_OFFER_METADATA_DESCRIPTION'
// Bnbl modal actions
export const UPDATE_GIFTING_BNBL_MODAL = 'UPDATE_GIFTING_BNBL_MODAL'
export const INITIALISE_BNBL_MODAL = 'INITIALISE_BNBL_MODAL'
export const UPDATE_BNBL_NUMBER_OF_ROOMS = 'UPDATE_BNBL_NUMBER_OF_ROOMS'
export const UPDATE_BNBL_PACKAGE_VIEW = 'UPDATE_BNBL_PACKAGE_VIEW'

// API based actions
/**
 * The default API action that will fire a success/request/failure
 */
export const API_CALL = 'API_CALL'
export const API_CALL_FAILURE = 'API_CALL_FAILURE'
export const API_CALL_REQUEST = 'API_CALL_REQUEST'
export const API_CALL_SUCCESS = 'API_CALL_SUCCESS'

// Flight based actions
export const CLEAR_FLIGHT_RESULT = 'CLEAR_FLIGHT_RESULT'
export const UPDATE_FLIGHT_FILTERS = 'UPDATE_FLIGHT_FILTERS'
export const UPDATE_FLIGHTS_SORT = 'UPDATE_FLIGHTS_SORT'
export const FETCH_AIRLINES = 'FETCH_AIRLINES'
export const FETCH_AIRPORTS = 'FETCH_AIRPORTS'
export const FETCH_POPULAR_AIRPORTS = 'FETCH_POPULAR_AIRPORTS'
export const SET_FLIGHTS_CREDIT_DATA = 'SET_FLIGHTS_CREDIT_DATA'
export const FETCH_FLIGHT_CREDIT_RESERVATION = 'FETCH_FLIGHT_CREDIT_RESERVATION'
export const FETCH_FLIGHT_DEALS = 'FETCH_FLIGHT_DEALS'
export const FETCH_FLIGHT_DEAL = 'FETCH_FLIGHT_DEAL'
export const FETCH_FLIGHT_CAMPAIGNS = 'FETCH_FLIGHT_CAMPAIGNS'
export const FETCH_FLIGHT_CAMPAIGN = 'FETCH_FLIGHT_CAMPAIGN'
export const FETCH_FLIGHT_CAMPAIGN_DEALS = 'FETCH_FLIGHT_CAMPAIGN_DEALS'
export const UPDATE_FLIGHT_TRAVELLERS = 'UPDATE_FLIGHT_TRAVELLERS'
export const UPDATE_FLIGHT_SEAT_SELECTIONS = 'UPDATE_FLIGHT_SEAT_SELECTIONS'
export const CLEAR_FLIGHT_SEAT_SELECTIONS = 'CLEAR_FLIGHT_SEAT_SELECTIONS'

// Analytics based actions
export const PAGE_VIEW = 'PAGE_VIEW'
export const PRODUCT_CLICK_VIEW_DETAILS = 'PRODUCT_CLICK_VIEW_DETAILS'
export const MAP_PROPERTY_PIN_CLICK = 'MAP_PROPERTY_PIN_CLICK'
export const MAP_OFFER_INFO_CLICK = 'MAP_OFFER_INFO_CLICK'
export const MAP_PIN_OFFER_VIEW = 'MAP_PIN_OFFER_VIEW'
export const DEAL_VIDEO_PLAYED = 'DEAL_VIDEO_PLAYED'
export const DEAL_VIDEO_PAUSED = 'DEAL_VIDEO_PAUSED'
export const OFFER_PRODUCT_DETAIL_VIEW = 'OFFER_PRODUCT_DETAIL_VIEW'
export const PACKAGE_VIEW_MORE_DETAILS_CLICK = 'PACKAGE_VIEW_MORE_DETAILS_CLICK'
export const INITIALISE_SEARCH_SESSION_ID = 'INITIALISE_SEARCH_SESSION_ID'
export const SET_OFFER_CHECK_IN_CHECK_OUT = 'SET_OFFER_CHECK_IN_CHECK_OUT'
export const SET_OFFER_LERE_INLINE_YMAL_IN_VIEW = 'SET_OFFER_LERE_INLINE_YMAL_IN_VIEW'
export const CLEAR_OFFER_CHECK_IN_CHECK_OUT = 'CLEAR_OFFER_CHECK_IN_CHECK_OUT'

// Calendar based actions
export const CLEAR_BOOKING_CALENDAR = 'CLEAR_BOOKING_CALENDAR'
export const CALENDAR_UPDATE_PRICING_DATA = 'CALENDAR_UPDATE_PRICING_DATA'

// UI based actions
export const MODAL_OPEN = 'MODAL_OPEN'
export const BOOKING_DATE_WARNING_MODAL_OPEN = 'BOOKING_DATE_WARNING_MODAL_OPEN'
export const HOTEL_PRICE_CHANGE_MODAL_OPEN = 'HOTEL_PRICE_CHANGE_MODAL_OPEN'
export const BUNDLE_PRICE_CHANGE_MODAL_OPEN = 'BUNDLE_PRICE_CHANGE_MODAL_OPEN'
export const BEDBANK_HOTEL_PRICE_CHANGE_MODAL_OPEN = 'BEDBANK_HOTEL_PRICE_CHANGE_MODAL_OPEN'
export const TOUR_V2_PRICE_CHANGE_MODAL_OPEN = 'TOUR_V2_PRICE_CHANGE_MODAL_OPEN'
export const JOURNEY_PRICE_CHANGE_MODAL_OPEN = 'JOURNEY_PRICE_CHANGE_MODAL_OPEN'
export const JOURNEY_SOLD_OUT_MODAL_OPEN = 'JOURNEY_SOLD_OUT_MODAL_OPEN'
export const FLIGHT_SEATS_UNAVAILABLE_MODAL_OPEN = 'FLIGHT_SEATS_UNAVAILABLE_MODAL_OPEN'
export const CANT_PROCESS_ORDER_ONLINE_MODAL_OPEN = 'CANT_PROCESS_ORDER_ONLINE_MODAL_OPEN'
export const FLIGHTS_SESSION_EXPIRED_MODAL_OPEN = 'FLIGHTS_SESSION_EXPIRED_MODAL_OPEN'
export const GENERIC_ORDER_ERROR_MODAL_OPEN = 'GENERIC_ORDER_ERROR_MODAL_OPEN'
export const AUTH_MODAL_OPEN = 'AUTH_MODAL_OPEN'
export const QUOTE_EMAIL_MODAL_OPEN = 'QUOTE_EMAIL_MODAL_OPEN'
export const CART_LINK_MODAL_OPEN = 'CART_LINK_MODAL_OPEN'
export const TERMS_AND_CONDITIONS_MODAL_OPEN = 'TERMS_AND_CONDITIONS_MODAL_OPEN'
export const MERCHANDISE_INVALID_REGION_MODAL_OPEN = 'MERCHANDISE_INVALID_REGION_MODAL_OPEN'
export const CONFIRMATION_EMAIL_MODAL_OPEN = 'CONFIRMATION_EMAIL_MODAL_OPEN'
export const MODAL_CLOSE = 'MODAL_CLOSE'
export const ACCOUNT_ACCESS_SHOW_PARTNERSHIP_LINK = 'ACCOUNT_ACCESS_SHOW_PARTNERSHIP_LINK'
export const SHOW_BRIDGER_PAY_PAYMENT_MODAL = 'SHOW_BRIDGER_PAY_PAYMENT_MODAL'
export const ADD_PAYMENT_PROVIDER = 'ADD_PAYMENT_PROVIDER'
export const SHOW_BRIDGERPAY_PAYMENT_FAILED_MODAL = 'SHOW_BRIDGERPAY_PAYMENT_FAILED_MODAL'
export const SHOW_CUSTOMER_SIGNATURE_MODAL = 'SHOW_CUSTOMER_SIGNATURE_MODAL'
export const SHOW_CHECKOUT_CART_MODE_MODAL = 'SHOW_CHECKOUT_CART_MODE_MODAL'
export const SHOW_PAY_TO_AUTHORISATION_MODAL = 'SHOW_PAY_TO_AUTHORISATION_MODAL'
export const SHOW_PAY_ID_AUTHORISATION_MODAL = 'SHOW_PAY_ID_AUTHORISATION_MODAL'
export const BEDBANK_SOLD_OUT_MODAL_OPEN = 'BEDBANK_SOLD_OUT_MODAL_OPEN'
export const SHOW_EXPERIENCE_CANCELLATION_MODAL = 'SHOW_EXPERIENCE_CANCELLATION_MODAL'
export const SHOW_SECURE_PAYMENT_MODAL = 'SHOW_SECURE_PAYMENT_MODAL'

// Temp url params based actions
export const SET_PREFILL_QFF_NUMBER = 'SET_PREFILL_QFF_NUMBER'

// Content actions
export const DISMISS_NOTIFICATION_BANNER = 'DISMISS_NOTIFICATION_BANNER'

// BedbankOffer actions
export const BEDBANK_OFFER_PRODUCT_DETAIL_VIEW = 'BEDBANK_OFFER_PRODUCT_DETAIL_VIEW'
export const TOUR_V2_OFFER_PRODUCT_DETAIL_VIEW = 'TOUR_V2_OFFER_PRODUCT_DETAIL_VIEW'
export const TOUR_V2_OFFER_VARIATION_VIEW = 'TOUR_V2_OFFER_VARIATION_VIEW'
export const SET_TOUR_V2_SELECTED_PACKAGE_TYPE = 'SET_TOUR_V2_SELECTED_PACKAGE_TYPE'

// Cruise actions
export const SAVE_CABIN_OPTION = 'SAVE_CABIN_OPTION'
export const RESET_REVELEX_CALLS = 'RESET_REVELEX_CALLS'
export const RESET_CABIN_AVAILABILITY = 'RESET_CABIN_AVAILABILITY'
export const CRUISE_SET_SEARCH_FACETS = 'CRUISE_SET_SEARCH_FACETS'
export const CRUISE_SET_CRUISE_LINES = 'CRUISE_SET_CRUISE_LINES'
export const RESET_BOOKING_CABIN_SELECTION = 'RESET_BOOKING_CABIN_SELECTION'
export const SET_BOOKING_INTEREST_IN_CONNECTED_CABINS = 'SET_BOOKING_INTEREST_IN_CONNECTED_CABINS'
export const SET_CRUISE_OFFER_PLACES = 'SET_CRUISE_OFFER_PLACES'

// Checkout actions
export const CHECKOUT_INITIALISE = 'CHECKOUT_INITIALISE'
export const CHECKOUT_RESTORE_CART = 'CHECKOUT_RESTORE_CART'
export const CHECKOUT_REMOVE_TRAVELLER_SCHEMA = 'CHECKOUT_REMOVE_TRAVELLER_SCHEMA'
export const CHECKOUT_INITIALISE_FORM = 'CHECKOUT_INITIALISE_FORM'
export const CHECKOUT_RESET_FORM = 'CHECKOUT_RESET_FORM'
export const CHECKOUT_RESTORE_PAYMENT = 'CHECKOUT_RESTORE_PAYMENT'
export const CHECKOUT_UPDATE_ITEM = 'CHECKOUT_UPDATE_ITEM'
export const CHECKOUT_ADD_ITEM = 'CHECKOUT_ADD_ITEM'
export const CHECKOUT_REMOVE_ITEM = 'CHECKOUT_REMOVE_ITEM'
export const CHECKOUT_SET_FORM = 'CHECKOUT_SET_FORM'
export const CHECKOUT_CLEAR_TRAVELLER_FORM = 'CHECKOUT_CLEAR_TRAVELLER_FORM'
export const CHECKOUT_PROCESS_START = 'CHECKOUT_PROCESS_START'
export const CHECKOUT_PROCESS_CANCEL = 'CHECKOUT_PROCESS_CANCEL'
export const CHECKOUT_PROCESS_SUCCESS = 'CHECKOUT_PROCESS_SUCCESS'
export const CHECKOUT_PROCESS_FAILURE = 'CHECKOUT_PROCESS_FAILURE'
export const CHECKOUT_UPDATE_PAYMENT_SELECTION = 'CHECKOUT_UPDATE_PAYMENT_SELECTION'
export const CHECKOUT_SELECT_STATIC_SCHEDULE_OPTION = 'CHECKOUT_SELECT_STATIC_SCHEDULE_OPTION'
export const CHECKOUT_SET_PAYMENT_SCHEDULE_BALANCE_TYPE = 'CHECKOUT_SET_PAYMENT_SCHEDULE_BALANCE_TYPE'
export const CHECKOUT_SET_PAYMENT_SCHEDULE_FULL_BALANCE_ONLY = 'CHECKOUT_SET_PAYMENT_SCHEDULE_FULL_BALANCE_ONLY'
export const CHECKOUT_SET_DYNAMIC_PAYMENT_SCHEDULE_FREQUENCY = 'CHECKOUT_SET_DYNAMIC_PAYMENT_SCHEDULE_FREQUENCY'
export const SET_TERMINAL_READER_ID = 'SET_TERMINAL_READER_ID'
export const CHECKOUT_SET_LUXPLUS_UPSELL_DATA = 'CHECKOUT_SET_LUXPLUS_UPSELL_DATA'
export const CHECKOUT_FETCHING_PROMO_CODE = 'CHECKOUT_FETCHING_PROMO_CODE'
export const CHECKOUT_APPLY_PROMO_CODE = 'CHECKOUT_APPLY_PROMO_CODE'
export const CHECKOUT_APPLY_PROMO_CODE_FAILED = 'CHECKOUT_APPLY_PROMO_CODE_FAILED'
export const CHECKOUT_RESET_PROMO_CODE = 'CHECKOUT_RESET_PROMO_CODE'
export const CHECKOUT_RESET_FLIGHT_ITEMS = 'CHECKOUT_RESET_FLIGHT_ITEMS'
export const CHECKOUT_UPDATE_FLIGHT_TOTAL_FARE = 'CHECKOUT_UPDATE_FLIGHT_TOTAL_FARE'
export const CHECKOUT_CLEAR_CART_RESTORE_PRICE = 'CHECKOUT_CLEAR_CART_RESTORE_PRICE'
// These are just alternate versions of the Qantas actions above, for the new checkout state
export const CHECKOUT_APPLY_VELOCITY_BURN = 'CHECKOUT_APPLY_VELOCITY_BURN'
export const CHECKOUT_CLEAR_VELOCITY_BURN = 'CHECKOUT_CLEAR_VELOCITY_BURN'
export const CHECKOUT_SET_VELOCITY_BURN_MODAL_STATUS = 'CHECKOUT_SET_VELOCITY_BURN_MODAL_STATUS'
export const CHECKOUT_APPLY_PARTNERSHIP_STATUS = 'CHECKOUT_APPLY_PARTNERSHIP_STATUS'
export const CHECKOUT_SET_SPECIAL_REQUEST = 'CHECKOUT_SET_SPECIAL_REQUEST'
export const CHECKOUT_ADD_ROOMS_TO_BE_CONNECTED = 'CHECKOUT_ADD_ROOMS_TO_BE_CONNECTED'
export const CHECKOUT_REMOVE_ROOMS_TO_BE_CONNECTED = 'CHECKOUT_REMOVE_ROOMS_TO_BE_CONNECTED'
export const CHECKOUT_TOGGLE_CREDIT = 'CHECKOUT_TOGGLE_CREDIT'
export const CHECKOUT_TOGGLE_GIFT_CARD = 'CHECKOUT_TOGGLE_GIFT_CARD'
export const CHECKOUT_SET_CLASSIC_REWARDS = 'CHECKOUT_SET_CLASSIC_REWARDS'
export const CHECKOUT_UPDATE_FLIGHT_ITEM_PAX_BAGGAGE = 'CHECKOUT_UPDATE_FLIGHT_ITEM_PAX_BAGGAGE'
export const CHECKOUT_UPDATE_FLIGHT_SEAT_SELECTIONS = 'CHECKOUT_UPDATE_FLIGHT_SEAT_SELECTIONS'
export const CHECKOUT_CLEAR_FLIGHT_SEAT_SELECTIONS = 'CHECKOUT_CLEAR_FLIGHT_SEAT_SELECTIONS'
export const CHECKOUT_UPDATE_ECONOMY_LUX_COUPLES_CONFIGURATION = 'CHECKOUT_UPDATE_ECONOMY_LUX_COUPLES_CONFIGURATION'
export const CHECKOUT_CLEAR_ECONOMY_LUX_COUPLES_CONFIGURATION = 'CHECKOUT_CLEAR_ECONOMY_LUX_COUPLES_CONFIGURATION'
export const CHECKOUT_SHOW_PROMO_CORPORATE_BENEFITS = 'CHECKOUT_SHOW_PROMO_CORPORATE_BENEFITS'
export const CHECKOUT_HIDE_PROMO_CORPORATE_BENEFITS = 'CHECKOUT_HIDE_PROMO_CORPORATE_BENEFITS'
export const CHECKOUT_SHOW_PROMO_FRIENDS_AND_FAMILY = 'CHECKOUT_SHOW_PROMO_FRIENDS_AND_FAMILY'
export const CHECKOUT_HIDE_PROMO_FRIENDS_AND_FAMILY = 'CHECKOUT_HIDE_PROMO_FRIENDS_AND_FAMILY'
export const CHECKOUT_SET_RESTORE_CART_STATUS = 'CHECKOUT_SET_RESTORE_CART_STATUS'
export const CHECKOUT_MODIFY_FLIGHT_SEARCH_VIEW = 'CHECKOUT_MODIFY_FLIGHT_SEARCH_VIEW'
export const CHECKOUT_SET_POST_PURCHASE = 'CHECKOUT_SET_POST_PURCHASE'
export const CHECKOUT_UPDATE_HOTEL_ITEM_PRICING = 'CHECKOUT_UPDATE_HOTEL_ITEM_PRICING'
export const CHECKOUT_UPDATE_BUNDLE_ITEM_PRICING = 'CHECKOUT_UPDATE_BUNDLE_ITEM_PRICING'
export const CHECKOUT_TOGGLE_DEV_TOOLS = 'CHECKOUT_TOGGLE_DEV_TOOLS'
export const CHECKOUT_CLEAR_CART = 'CHECKOUT_CLEAR_CART'
export const CHECKOUT_UPDATE_ARRIVAL_FLIGHT_NUMBER = 'UPDATE_ARRIVAL_FLIGHT_NUMBER'
export const CHECKOUT_AGENT_BOOKING_DETAILS = 'CHECKOUT_AGENT_BOOKING_DETAILS'
export const CHECKOUT_SET_MULTI_CART_ITEM_MODE = 'CHECKOUT_SET_MULTI_CART_ITEM_MODE'
export const CHECKOUT_SET_MERCHANT_FEE_PAYMENT_TYPE = 'CHECKOUT_SET_MERCHANT_FEE_PAYMENT_TYPE'
export const SET_PAYPAL_PAYMENT_TYPE = 'SET_PAYPAL_PAYMENT_TYPE'
export const CHECKOUT_SET_COMMS_RESUBSCRIBE = 'CHECKOUT_SET_COMMS_RESUBSCRIBE'
export const UPDATE_PAYMENT_SELECTION = 'UPDATE_PAYMENT_SELECTION'
export const ACTIVATE_REBOOKING = 'ACTIVATE_REBOOKING'
export const ACTIVATE_PAYMENT_SCHEDULE_REBOOKING = 'ACTIVATE_PAYMENT_SCHEDULE_REBOOKING'
export const CLEAR_PAYMENT_SCHEDULE_REBOOKING = 'CLEAR_PAYMENT_SCHEDULE_REBOOKING'
export const APPLY_PROMO_CODE = 'APPLY_PROMO_CODE'
export const CHECKOUT_RESET_COMMISSION = 'CHECKOUT_RESET_COMMISSION'
export const CHECKOUT_TOGGLE_LOYALTY_SIGNUP = 'CHECKOUT_TOGGLE_LOYALTY_SIGNUP'
export const CHECKOUT_LOYALTY_UPDATE_POINTS_TO_BURN = 'CHECKOUT_LOYALTY_UPDATE_POINTS_TO_BURN'
export const CHECKOUT_RESTORE_LOYALTY_UPDATE_POINTS_TO_BURN = 'CHECKOUT_RESTORE_LOYALTY_UPDATE_POINTS_TO_BURN'
export const CHECKOUT_SET_MODE = 'CHECKOUT_SET_MODE'
export const CHECKOUT_SET_HAS_CAR_HIRE_INTENTION = 'CHECKOUT_SET_HAS_CAR_HIRE_INTENTION'
export const SET_BEDBANK_SESSION = 'SET_BEDBANK_SESSION'
export const CHECKOUT_VALIDATE_OFFER_DISCOUNT = 'CHECKOUT_VALIDATE_OFFER_DISCOUNT'

export const CHECKOUT_SET_CHARTER_UPGRADE = 'CHECKOUT_SET_CHARTER_UPGRADE'

export const CHECKOUT_CLEAR_RESTORED_PROMO_CODE = 'CHECKOUT_CLEAR_RESTORED_PROMO_CODE'
export const CHECKOUT_CLEAR_RESTORED_USE_CREDIT = 'CHECKOUT_CLEAR_RESTORED_USE_CREDIT'
export const CHECKOUT_TOGGLE_FAILED_ITEMS = 'CHECKOUT_TOGGLE_FAILED_ITEMS'
export const CHECKOUT_SET_DELIVERY_FORM = 'CHECKOUT_SET_DELIVERY_FORM'
export const FLIGHTS_DATE_CHANGE_SET_STEP = 'FLIGHTS_DATE_CHANGE_SET_STEP'
export const FLIGHTS_DATE_CHANGE_SELECTED_LEGS_TO_CHANGE = 'FLIGHTS_DATE_CHANGE_SELECTED_LEGS_TO_CHANGE'
export const FLIGHTS_DATE_CHANGE_NEW_LEGS_WITH_DATES = 'FLIGHTS_DATE_CHANGE_NEW_LEGS_WITH_DATES'
export const FLIGHTS_DATE_CHANGE_RESET = 'FLIGHTS_DATE_CHANGE_RESET'

// Experience Actions
export const EXPERIENCE_VIEWED = 'EXPERIENCE_VIEWED'
export const SET_EXPERIENCE_PLACE = 'SET_EXPERIENCE_PLACE'
export const SET_CANCELLING_EXPERIENCES = 'SET_CANCELLING_EXPERIENCES'
export const CLEAR_EXPERIENCE_TIMES = 'CLEAR_EXPERIENCE_TIMES'
export const CLEAR_EXPERIENCE = 'CLEAR_EXPERIENCE'

// Navigation actions
export const PATH_CHANGE = 'PATH_CHANGE'

// Tour traveller details actions
export const TOUR_TRAVELLER_DETAILS_RESET_SUBMISSION = 'TOUR_TRAVELLER_DETAILS_RESET_SUBMISSION'
export const TOUR_TRAVELLER_DETAILS_UPDATE_SUBMITTED = 'TOUR_TRAVELLER_DETAILS_UPDATE_SUBMITTED'

// User reviews
export const USER_REVIEW_SET_PHOTO_UPLOAD_PERCENTAGE = 'USER_REVIEW_SET_PHOTO_UPLOAD_PERCENTAGE'
export const USER_REVIEW_SET_REVIEW_STAGE = 'USER_REVIEW_SET_REVIEW_STAGE'

// Velocity Auth
export const CHECKOUT_SET_VELOCITY_SSO = 'CHECKOUT_SET_VELOCITY_SSO'

// Sticky prompt card
export const ENABLE_STICKY_PROMPT_CARD = 'ENABLE_STICKY_PROMPT_CARD'
export const DISABLE_STICKY_PROMPT_CARD = 'DISABLE_STICKY_PROMPT_CARD'

export const CHECKOUT_UPDATE_CS_DEPOSIT_OVERRIDE = 'CHECKOUT_UPDATE_CS_DEPOSIT_OVERRIDE'

// LERE actions
export const LERE_SAVE_HOT_LEADS = 'LERE_SAVE_HOT_LEADS'
export const LERE_REMOVE_HIGH_INTENT = 'LERE_REMOVE_HIGH_INTENT'
export const LERE_SAVE_ABANDONED_CART = 'LERE_SAVE_ABANDONED_CART'
export const LERE_DISMISS_ALL_STICKY_ABANDONED_CART = 'LERE_DISMISS_ALL_STICKY_ABANDONED_CART'
export const LERE_REMOVE_ABANDONED_CART = 'LERE_REMOVE_ABANDONED_CART'
export const LERE_RESET_PERSONALISED_PREFERENCES = 'LERE_RESET_PERSONALISED_PREFERENCES'

// LuxPlus+ actions
export const CLEAR_LUX_PLUS_MEMBER_SUBSCRIPTION = 'CLEAR_LUX_PLUS_MEMBER_SUBSCRIPTION'
export const TOGGLE_SHOP_AS_MEMBER = 'TOGGLE_SHOP_AS_MEMBER'
// Agent hub
export const SET_CUSTOMER_VIEW_TOGGLE = 'SET_CUSTOMER_VIEW_TOGGLE'
export const SET_AGENT_EXTRA_EARNINGS = 'SET_AGENT_EXTRA_EARNINGS'
export const SET_SOCIETE_REQUESTS_INTERACTIONS = 'SET_SOCIETE_REQUESTS_INTERACTIONS'
export const CHECKOUT_SET_AGENT_HUB_PAYMENT_SETUP = 'CHECKOUT_SET_AGENT_HUB_PAYMENT_SETUP'

export const CHECKOUT_SET_STRIPE_PAYMENT_METHOD = 'CHECKOUT_SET_STRIPE_PAYMENT_METHOD'

// SherLog actions
export const LOG_NETWORK_REQUEST = 'LOG_NETWORK_REQUEST'
export const LOG_NETWORK_RESPONSE = 'LOG_NETWORK_RESPONSE'

// Arrival Details
export const CHECKOUT_ADD_ARRIVAL_DETAILS = 'CHECKOUT_ADD_ARRIVAL_DETAILS'
export const CHECKOUT_SET_ARRIVAL_DETAILS_TIME = 'CHECKOUT_SET_ARRIVAL_DETAILS_TIME'
export const CHECKOUT_SET_ARRIVAL_DETAILS_FLIGHT_NUMBER = 'CHECKOUT_SET_ARRIVAL_DETAILS_FLIGHT_NUMBER'

// PayTo
export const CHECKOUT_SET_PAYTO_BANK = 'CHECKOUT_SET_PAYTO_BANK'

// Support Assistant Actions
export const SET_CURRENT_CHAT_ID = 'SET_CURRENT_CHAT_ID'
export const ADD_DEFAULT_CHAT = 'ADD_DEFAULT_CHAT'
export const UPDATE_CHAT = 'UPDATE_CHAT'
export const UPDATE_CHAT_TITLE = 'UPDATE_CHAT_TITLE'
export const ADD_CHAT_MESSAGE = 'ADD_CHAT_MESSAGE'
export const SET_CHAT_MESSAGES = 'SET_CHAT_MESSAGES'
export const SET_CHAT_OUTAGE_MESSAGE = 'SET_CHAT_OUTAGE_MESSAGE'
export const SET_LAST_UPDATED_AT = 'SET_LAST_UPDATED_AT'
export const SET_UNREAD_MESSAGE_COUNT = 'SET_UNREAD_MESSAGE_COUNT'

// Secure Payment
export const CHECKOUT_FETCHING_PAYMENT_LINK = 'CHECKOUT_FETCHING_PAYMENT_LINK'
export const CHECKOUT_SET_PAYMENT_LINK = 'CHECKOUT_SET_PAYMENT_LINK'
export const CHECKOUT_SET_VOUCHER_IDS = 'CHECKOUT_SET_VOUCHER_IDS'
export const CHECKOUT_CLEAR_VOUCHER_IDS = 'CHECKOUT_CLEAR_VOUCHER_IDS'
export const CHECKOUT_SET_AGENT_REQUEST_3DS = 'CHECKOUT_SET_AGENT_REQUEST_3DS'
export const CHECKOUT_FETCHING_VOUCHERS = 'CHECKOUT_FETCHING_VOUCHERS'
export const CHECKOUT_SET_VOUCHERS = 'CHECKOUT_SET_VOUCHERS'
export const CHECKOUT_FETCHING_VOUCHERS_FAILED = 'CHECKOUT_FETCHING_VOUCHERS_FAILED'
export const FETCH_ALL_VOUCHERS = 'FETCH_ALL_VOUCHERS'
export const CHECKOUT_FETCHING_PAYMENT_LINK_FAILED = 'CHECKOUT_FETCHING_PAYMENT_LINK_FAILED'
export const SECURE_PAYMENT_SET_PROCESSING = 'SECURE_PAYMENT_SET_PROCESSING'
export const SECURE_PAYMENT_SET_STRIPE_PAYMENT_METHOD = 'SECURE_PAYMENT_SET_STRIPE_PAYMENT_METHOD'
export const SECURE_PAYMENT_SET_MERCHANT_FEE_PAYMENT_TYPE = 'SECURE_PAYMENT_SET_MERCHANT_FEE_PAYMENT_TYPE'
export const SECURE_PAYMENT_SET_ERROR = 'SECURE_PAYMENT_SET_ERROR'
export const SECURE_PAYMENT_SET_PAID = 'SECURE_PAYMENT_SET_PAID'
export const SECURE_PAYMENT_SET_LOADING = 'SECURE_PAYMENT_SET_LOADING'
export const SECURE_PAYMENT_SET_EXPIRED = 'SECURE_PAYMENT_SET_EXPIRED'
export const SECURE_PAYMENT_SET_INFO = 'SECURE_PAYMENT_SET_INFO'
export const SECURE_PAYMENT_SET_SUCCESS = 'SECURE_PAYMENT_SET_SUCCESS'

// Search
export const CREATE_SEARCH = 'CREATE_SEARCH'
export const FETCH_RECENT_SEARCHES = 'FETCH_RECENT_SEARCHES'
export const SET_RECENT_SEARCHES = 'SET_RECENT_SEARCHES'
export const CREATE_SEARCH_SESSION = 'CREATE_SEARCH_SESSION'

// Typeahead Streaming
export const TYPEAHEAD_STREAMING_START = 'TYPEAHEAD_STREAMING_START'
export const TYPEAHEAD_STREAMING_UPDATE = 'TYPEAHEAD_STREAMING_UPDATE'
export const TYPEAHEAD_STREAMING_COMPLETE = 'TYPEAHEAD_STREAMING_COMPLETE'
export const TYPEAHEAD_STREAMING_ERROR = 'TYPEAHEAD_STREAMING_ERROR'
export const SET_TYPEAHEAD_STREAMING_SOCKET_STATUS = 'SET_TYPEAHEAD_STREAMING_SOCKET_STATUS'
export const SET_TYPEAHEAD_USER_SELECTED_DATES = 'SET_TYPEAHEAD_USER_SELECTED_DATES'
export const SET_TYPEAHEAD_USER_SELECTED_OCCUPANCY = 'SET_TYPEAHEAD_USER_SELECTED_OCCUPANCY'

// Fetch Channel Markup
export const FETCH_CHANNEL_MARKUP = 'FETCH_CHANNEL_MARKUP'

// Meta Offers Discount
export const FETCH_META_OFFERS_DISCOUNT = 'FETCH_META_OFFERS_DISCOUNT'

// Metasearch
export const SET_METASEARCH_PROPERTY_BLACKLIST = 'SET_METASEARCH_PROPERTY_BLACKLIST'
export const SET_AUTO_APPLIED_VOUCHER = 'SET_AUTO_APPLIED_VOUCHER'

// Customer Traveller
export const RESET_CUSTOMER_TRAVELLER_SUBMISSION = 'RESET_CUSTOMER_TRAVELLER_SUBMISSION'

// Loyalty
export const CLEAR_LOYALTY_ENROLMENT = 'CLEAR_LOYALTY_ENROLMENT'
export const UPDATE_LOYALTY_ESIM_CODE = 'UPDATE_LOYALTY_ESIM_CODE'
export const SET_LOYALTY_ESIM_CRUISE_CODES = 'SET_LOYALTY_ESIM_CRUISE_CODES'
export const CHECKOUT_UPDATE_SOCIETE_MEMBER_NUMBER = 'CHECKOUT_UPDATE_SOCIETE_MEMBER_NUMBER'
export const FETCH_LOYALTY_ACCOUNT_EXISTS = 'FETCH_LOYALTY_ACCOUNT_EXISTS'

export const REDEEM_GIFT_CARD = 'REDEEM_GIFT_CARD'
export const CLEAR_REDEEMED_GIFT_CARDS = 'CLEAR_REDEEMED_GIFT_CARDS'
export const REMOVE_REDEEMED_GIFT_CARD = 'REMOVE_REDEEMED_GIFT_CARD'

// Offer Comparison
export const OFFER_COMPARISON_RESTORE_STATE = 'OFFER_COMPARISON_RESTORE_STATE'
export const OFFER_COMPARISON_TOGGLE_ENABLED = 'OFFER_COMPARISON_TOGGLE_ENABLED'
export const OFFER_COMPARISON_ADD_SELECTION = 'OFFER_COMPARISON_ADD_SELECTION'
export const OFFER_COMPARISON_REMOVE_SELECTION = 'OFFER_COMPARISON_REMOVE_SELECTION'
export const OFFER_COMPARISON_TOGGLE_SELECTION = 'OFFER_COMPARISON_TOGGLE_SELECTION'
export const OFFER_COMPARISON_REPLACE_SELECTION = 'OFFER_COMPARISON_REPLACE_SELECTION'
export const OFFER_COMPARISON_CLEAR_ALL = 'OFFER_COMPARISON_CLEAR_ALL'

// Cart Offer Comparison
export const CART_OFFER_COMPARISON_ADD_SELECTION = 'CART_OFFER_COMPARISON_ADD_SELECTION'
export const CART_OFFER_COMPARISON_REMOVE_SELECTION = 'CART_OFFER_COMPARISON_REMOVE_SELECTION'
export const CART_OFFER_COMPARISON_REPLACE_SELECTION = 'CART_OFFER_COMPARISON_REPLACE_SELECTION'
export const CART_OFFER_COMPARISON_CLEAR_ALL = 'CART_OFFER_COMPARISON_CLEAR_ALL'

export const SET_BYPASS_REGION_FILTER = 'SET_BYPASS_REGION_FILTER'
export const SET_BYPASS_REGION_EXCLUSION_OFFER_IDS = 'SET_BYPASS_REGION_EXCLUSION_OFFER_IDS'
